import { FC } from 'react';

import styles from '../../Encounters.module.scss';
import { EncounterGroup } from '../../lib/groupEncountersByDay';

import { DayLabel } from './DayLabel';
import { EncounterListItem } from './EncounterListItem';

type EncounterListGroupProps = {
  group: EncounterGroup;
  selectedEncounterId: string | undefined;
  onSelect: (encounterId: string) => void;
};

export const EncounterListGroup: FC<EncounterListGroupProps> = (props) => {
  const { group, selectedEncounterId, onSelect } = props;

  return (
    <div className={styles.group} data-component="encounter-day-group">
      <div className={styles.groupLabel}>
        <DayLabel date={group.dayDate} />
      </div>
      {group.items.map((encounter) => (
        <EncounterListItem
          key={encounter.id}
          encounter={encounter}
          isSelected={encounter.id === selectedEncounterId}
          onSelect={onSelect}
        />
      ))}
    </div>
  );
};
